import { urlParams } from "../constants";
import { getParameter } from "./urlUtil";

export function getDefaultFormValues(cookieValues) {
    let defaultValues = {
        firstName: "",
        lastName: "",
        businessName: "",
        email: "",
        phoneNumber: "",
        city: "",
        state: ""
    };

    if (cookieValues) {
        for (var key in cookieValues) {
            if (key) {
                if (key === "phoneNumber") {    
                    defaultValues[key] = cookieValues[key].replaceAll(new RegExp("[^0-9]", "g"), "");
                }
                else {
                    defaultValues[key] = cookieValues[key];
                }           
            }
        }

        // rename configId parsed from response to userConfigId
        defaultValues.userConfigId = defaultValues.configId;
        delete defaultValues.configId;
    }

    let cid = getParameter(urlParams.campaignId);
    let isPaid = getParameter(urlParams.paidSearch) === "1";
    let icid = getParameter(urlParams.icId);

    return {
        ...defaultValues,
        contactPreferences: "",
        hearAbout: "",
        leadSource: "Welcome App",
        campaignId: cid ? cid.toUpperCase() : "",
        referringDomain: document.referrer,
        paidSearch: isPaid ? "Yes" : "No",
        visitId: "",
        icId: icid ? icid.toUpperCase() : "",
    };
}